import React from "react"

const IntegrationCallout = ({ icons, children }) => {
  return (
    <div className="integrations-callout mt-10">
      {icons.map(icon => (
        <span className="integrations-callout__icon">
          <img
            width="20"
            height="20"
            src={`/icons/integrations/${icon.src}`}
            alt={icon.alt}
          />
        </span>
      ))}
      {children}
    </div>
  )
}

export default IntegrationCallout
